import type { FC } from 'react';

import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@repo/utils/common';

const sizeVariants = cva('animate-spin', {
  variants: {
    size: {
      sm: 'size-6',
      md: 'size-8',
      lg: 'size-12',
      xl: 'size-16',
    },
  },
});

const borderVariants = cva('border-muted border-t-primary h-full w-full rounded-full', {
  variants: {
    size: {
      sm: 'border-3',
      md: 'border-4',
      lg: 'border-4',
      xl: 'border-5',
    },
  },
});

interface LoadingSpinnerProps {
  className?: string;
  size?: VariantProps<typeof sizeVariants>['size'];
}

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ className, size = 'md' }) => {
  return (
    <div className={cn(sizeVariants({ size }), className)}>
      <div className={cn(borderVariants({ size }))} />
    </div>
  );
};
